// The text a notification banner row shows once its owner has answered it.
//
// The bare value ("You answered: Yes") says nothing about what the answer did:
// a friend-transfer request answered "yes" means "request transfer to me", and
// "no" means "keep with <owner>". The chosen action's label carries that, so
// show it, and fall back to Yes/No for rows whose actions have no label.
export function answeredLabel(actions, responded) {
  const chosen = (actions || []).find((a) => a.value === responded);
  return chosen?.label || (responded === "yes" ? "Yes" : "No");
}
